import React from 'react'
import {Stack, styled} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import {colors} from '@/constants'
import {ReactComponent as SettingsIcon} from '@/assets/svgs/header/SettingsIcon.svg'
import {useAppSelector} from '@/hooks/redux'

import '@/styles/components/header/header.css'
import useModal from '@/hooks/modal'
import {selectAccount} from '@/store/selectors/storage'
import Profile from '@/components/Modals/Profile'

const Index = () => {
  const navigate = useNavigate()
  const account = useAppSelector(selectAccount)
  const {setModal} = useModal()
  const [open] = React.useState(false)
  const anchorRef = React.useRef<HTMLDivElement>(null)

  const handleOpenProfile = () => {
    setModal(<Profile navigate={navigate} />)
  }

  if (!account) {
    return null
  }

  return (
    <>
      <SettingsSVG
        ref={anchorRef}
        id="composition-button"
        aria-controls={open ? 'composition-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleOpenProfile}
        position="relative">
        <SettingsIcon style={{fill: colors.white}} />
      </SettingsSVG>
    </>
  )
}

export default Index

const SettingsSVG = styled(Stack)`
  &:hover {
    cursor: pointer;
    & > svg {
      fill: ${colors.orange}!important;
    }
  }
`
